import Vue from 'vue'

import VideoList from '@/views/parts/VideoList.vue'
/* Script */

Vue.config.productionTip = false

if (document.getElementById('video-list')) {
  new Vue({
    render: h => h(VideoList)
  }).$mount('#video-list')
}
